import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            精彩视频
          </h2>
          <p className="text-sm text-foreground-500">漫画推荐、角色赏析，用视频发现更多精彩内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-accent-200/60 transition-all cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-900/70 text-background-50 text-xs font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-foreground-900 text-sm mb-1 line-clamp-2">{item.title}</h3>
                <span className="text-xs text-foreground-500">{item.views} 次观看</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}